import React, { Component } from 'react'
import Style from './style.module.less'
import { CaretDownOutlined, RightOutlined } from '@ant-design/icons'
import { Select, Empty, Menu, Dropdown } from 'hljd'
import cls from 'classnames'
import { observer } from 'mobx-react'
import {
  TYPE_STATUS,
  APPOINTMENT_FORM,
  DEPOSIT_PAID,
  PAYMENT_COMPLETED,
  NO_ORDER_TAKING
} from '../constant'
import { isSiDaTeam, isSiYiTeam } from '@util'
import MemberSelect, { MEMBER_AUDIT_STATUS } from '@common/MemberSelect'

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const {
      groupMembers,
      daySchedules,
      scheduleSlot = [],
      onGroupMemberChange,
      groupMemberId,
      showModalVisable,
      onChangeStatus,
      isTeamSchedule
    } = store

    return (
      <div className={Style.content}>
        {(isSiDaTeam() || isTeamSchedule) && (
          <div className={Style['content-top']}>
            <span className={Style.span}>团队成员：</span>
            {isSiYiTeam() ? (
              <MemberSelect
                className={Style.select}
                reviewedStatus={MEMBER_AUDIT_STATUS.PASSED}
                value={groupMemberId}
                onSelect={onGroupMemberChange}
                showAll={false}
                extraOptions={[{ id: 0, name: '所有成员' }]}
              />
            ) : (
              <Select
                className={Style.select}
                value={groupMemberId}
                onChange={onGroupMemberChange}
              >
                {groupMembers.map(item => {
                  const isDisabled = !!(
                    item.merchantExtends.scheduleShow && isTeamSchedule
                  )
                  return (
                    <Select.Option
                      value={item.id}
                      key={item.id}
                      disabled={isDisabled}
                    >
                      {item.name} {isDisabled && '(不可见)'}
                    </Select.Option>
                  )
                })}
              </Select>
            )}
          </div>
        )}

        <div className={Style['content-list']}>
          {daySchedules.length == 0 && <Empty description="暂无档期" />}
          {daySchedules.map(item => {
            const {
              id,
              merchant = {},
              actualPrice,
              address,
              status,
              time,
              slot,
              customerName,
              emceeMember = {}
            } = item
            let logoPath = isSiYiTeam() ? emceeMember.avatar : merchant.logoPath
            let name = isSiYiTeam() ? emceeMember.name : merchant.name
            const slotObj = scheduleSlot.find(item => item.id == slot) || {}
            const menus = (
              <Menu>
                {Object.keys(TYPE_STATUS).map(key => {
                  return (
                    <Menu.Item key={key} onClick={onChangeStatus(item, key)}>
                      {TYPE_STATUS[key]}
                    </Menu.Item>
                  )
                })}
              </Menu>
            )

            return (
              <div key={id} className={Style.item}>
                {slot == NO_ORDER_TAKING && (
                  <div className={Style['item-left']}>
                    <div className={Style.name}>不接单</div>
                    <div
                      className={cls({
                        [Style.status]: true
                      })}
                    />
                  </div>
                )}
                {slot != NO_ORDER_TAKING && (
                  <div
                    className={cls({
                      [Style['item-left']]: true,
                      [Style.yellow]: status == PAYMENT_COMPLETED,
                      [Style.green]: status == DEPOSIT_PAID,
                      [Style.red]: status == APPOINTMENT_FORM
                    })}
                  >
                    {!!address && <div className={Style.name}>{address}</div>}
                    <div>
                      <span className={Style.span}>
                        {slotObj.name} {time}
                      </span>
                      <span className={Style.span}>
                        {customerName} {!!(customerName && +actualPrice) && '|'}{' '}
                        {!!+actualPrice && `￥${actualPrice}`}
                      </span>
                    </div>
                    <div
                      className={cls({
                        [Style.status]: true,
                        [Style.yellow]: status == PAYMENT_COMPLETED,
                        [Style.green]: status == DEPOSIT_PAID,
                        [Style.red]: status == APPOINTMENT_FORM
                      })}
                    >
                      {!isTeamSchedule ? (
                        <Dropdown overlay={menus} trigger={['click']}>
                          <div style={{ width: '100px' }}>
                            <span
                              style={{ userSelect: 'none', cursor: 'pointer' }}
                            >
                              {TYPE_STATUS[status]}
                            </span>
                            <CaretDownOutlined />
                          </div>
                        </Dropdown>
                      ) : (
                        <span style={{ userSelect: 'none' }}>
                          {' '}
                          {TYPE_STATUS[status]}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                {(isSiDaTeam() || isTeamSchedule) && (
                  <div
                    className={cls({
                      [Style['item-right']]: true,
                      [Style['cur-p']]: isSiDaTeam() && !isTeamSchedule
                    })}
                    onClick={showModalVisable(item)}
                  >
                    <img
                      src={
                        isSiYiTeam()
                          ? logoPath
                          : logoPath + '?imageView2/1/w/40/h/40'
                      }
                      style={{ width: 40, height: 40 }}
                    />
                    <div className={Style.name}>
                      <span title={name}>{name}</span>
                    </div>
                  </div>
                )}
                {!isTeamSchedule &&
                  !isSiDaTeam() && (
                    <RightOutlined
                      className={Style.iconRight}
                      onClick={showModalVisable(item)}
                    />
                  )}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}
